import { render, staticRenderFns } from "./ComanderosLista.vue?vue&type=template&id=59b4e885"
import script from "./ComanderosLista.vue?vue&type=script&lang=js"
export * from "./ComanderosLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports